const c = {
  name: "Oauth",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,1-0.3,2-0.8,2.8l3.2,3.2H24c1,0,2,0.3,2.8,0.8l4.1-4.1
			C30.3,7,30,6,30,5c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5c-1,0-2-0.3-2.8-0.8l-4.1,4.1C28.7,14,29,15,29,16v11.6
			l3.2,3.2C33,30.3,34,30,35,30c2.8,0,5,2.2,5,5c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-1,0.3-2,0.8-2.8L27.6,29H16c-1,0-2-0.3-2.8-0.8
			l-4.1,4.1C9.7,33,10,34,10,35c0,2.8-2.2,5-5,5c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5c1,0,2,0.3,2.8,0.8l4.1-4.1C11.3,26,11,25,11,24
			V12.4L7.8,9.2C7,9.7,6,10,5,10C2.2,10,0,7.8,0,5z M5,2C3.3,2,2,3.3,2,5c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C8,3.3,6.7,2,5,2z M35,2
			c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C38,3.3,36.7,2,35,2z M2,35c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3
			C3.3,32,2,33.3,2,35z M35,32c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C38,33.3,36.7,32,35,32z M13,24c0,1.7,1.3,3,3,3h11
			V16c0-1.7-1.3-3-3-3H13V24z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Oauth
};
